import React, { useEffect, useState } from "react";
import { dataUrl } from "../utils/api-urls";

const TotalStats = () => {
  const [totalStats, setTotalStats] = useState({
    confirmed: "",
    active: "",
    recovered: "",
    deaths: "",
  });
  useEffect(() => {
    getData();
  }, []);
  let getData = async () => {
    const rawData = await fetch(dataUrl);
    const jsonData = await rawData.json();
    setTotalStats({
      confirmed: jsonData.statewise[0].confirmed,
      active: jsonData.statewise[0].active,
      recovered: jsonData.statewise[0].recovered,
      deaths: jsonData.statewise[0].deaths,
    });
  };
  return (
    <>
      {(+totalStats.confirmed).toLocaleString() != 0 ? (
        <div className="total-stats-section">
          <div className="total-confirmed">
            <h5>Confirmed</h5>
            <h1>{(+totalStats.confirmed).toLocaleString()} </h1>
          </div>
          <div className="total-active">
            <h5>Active</h5>
            <h1>{(+totalStats.active).toLocaleString()}</h1>
          </div>
          <div className="total-recovered">
            <h5>Recovered</h5>
            <h1>{(+totalStats.recovered).toLocaleString()} </h1>
          </div>
          <div className="total-deceased">
            <h5>Deceased</h5>
            <h1>{(+totalStats.deaths).toLocaleString()}</h1>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default TotalStats;
